import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import { Seo } from "../components/Layout";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Connecté.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <Seo title="Admin" />
      <section className="pt-40 pb-32 min-h-[70vh] flex items-center" data-testid="login-section">
        <div className="max-w-md mx-auto w-full px-6">
          <h1 className="text-4xl font-serif text-sand-900 text-center">Espace administration</h1>
          <p className="text-center text-sand-600 mt-3">Connectez-vous pour gérer le blog.</p>
          <form onSubmit={onSubmit} className="mt-10 space-y-5 rounded-2xl bg-white/70 p-8 border border-sand-300/60 shadow-sm" data-testid="login-form">
            <div>
              <label htmlFor="email" className="block text-sm text-sand-700 mb-2">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                data-testid="login-email"
                className="w-full rounded-xl border border-sand-400 bg-white px-5 py-3 focus:outline-none focus:border-sand-500"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm text-sand-700 mb-2">Mot de passe</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                data-testid="login-password"
                className="w-full rounded-xl border border-sand-400 bg-white px-5 py-3 focus:outline-none focus:border-sand-500"
              />
            </div>
            <button type="submit" disabled={submitting} data-testid="login-submit" className="btn-primary w-full disabled:opacity-60">
              {submitting ? "Connexion…" : (<>Se connecter <LogIn size={16} /></>)}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
